var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13788 3.25016L1.63788 12.7502C1.55026 12.9019 1.50406 13.074 1.50391 13.2493C1.50375 13.4245 1.54965 13.5967 1.637 13.7486C1.72435 13.9006 1.85009 14.0268 2.00162 14.1149C2.15315 14.2029 2.32515 14.2495 2.50038 14.2502H13.5004C13.6756 14.2495 13.8476 14.2029 13.9991 14.1149C14.1507 14.0268 14.2764 13.9006 14.3638 13.7486C14.4511 13.5967 14.497 13.4245 14.4969 13.2493C14.4967 13.074 14.4505 12.9019 14.3629 12.7502L8.86288 3.25016C8.77592 3.0982 8.65036 2.97192 8.4989 2.88409C8.34744 2.79626 8.17547 2.75 8.00038 2.75C7.8253 2.75 7.65333 2.79626 7.50187 2.88409C7.35041 2.97192 7.22485 3.0982 7.13788 3.25016Z",
    fill: "#B87B1E",
    stroke: "#B87B1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.25V9.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75C8.41421 12.75 8.75 12.4142 8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeWarning);
export default __webpack_public_path__ + "static/media/orangeWarning.2ea1b40d149327c00bcfcc9fd71d6b25.svg";
export { ForwardRef as ReactComponent };